import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import './styles.css'
import { getLocaleUrls } from './lib/localeUrls.js'

const rootElement = document.getElementById('root')
rootElement.replaceChildren()

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

if ('serviceWorker' in navigator && import.meta.env.PROD && /^https?:$/.test(window.location.protocol)) {
  const applicationRoot = new URL(getLocaleUrls().base)
  window.addEventListener('load', () => navigator.serviceWorker.register(new URL('sw.js', applicationRoot), { scope: applicationRoot.pathname }))
}
